/*
 *
 * LoginPage reducer
 *
 */
import produce from 'immer';
import {
  SET_ENTITY_DIALOG_ASK_CONFIRMATION,
  SET_ENTITY_DIALOG_COMPONENT_NAME,
  SET_ENTITY_DIALOG_DATA_LOADING_STATUS,
  SET_ENTITY_DIALOG_DATA_SUCCESS_STATUS,
  SET_ENTITY_DIALOG_TITLE,
  SET_ENTITY_DIALOG_TITLE_APPENDER,
  SET_ENTITY_DIALOG_VISIBILiTY_STATUS,
} from './actionTypes';
import { LOGGED_OUT_ACTIONTYPE, RESET_APP_DATA_ACTIONTYPE } from '../../appContainer/actionTypes';
import { ENTITY_DIALOG_COMPONENT_NAMES } from './constants';

export const initialState = {
  isLoading: false,
  dataLoadStatus: false,
  showDialog: false,
  componentName: ENTITY_DIALOG_COMPONENT_NAMES.ADD_DEVICE,
  dialogTitle: 'Details',
  titleAppender: '',
  askConfirmation: false
};

/* eslint-disable default-case, no-param-reassign */
const entityDialogReducer = produce((draft, action) => {
  switch (action.type) {
    case SET_ENTITY_DIALOG_VISIBILiTY_STATUS.COMPLETED: {
      draft.showDialog = action.payload;
      break;
    }
    case SET_ENTITY_DIALOG_DATA_SUCCESS_STATUS.COMPLETED: {
      draft.dataLoadStatus = action.payload;
      break;
    }
    case SET_ENTITY_DIALOG_DATA_LOADING_STATUS.COMPLETED: {
      draft.isLoading = action.payload;
      break;
    }
    case SET_ENTITY_DIALOG_COMPONENT_NAME.COMPLETED: {
      draft.componentName = action.payload;
      break;
    }
    case SET_ENTITY_DIALOG_TITLE.COMPLETED: {
      draft.dialogTitle = action.payload;
      break;
    }
    case SET_ENTITY_DIALOG_TITLE_APPENDER.COMPLETED: {
      draft.titleAppender = action.payload;
      break;
    }
    case SET_ENTITY_DIALOG_ASK_CONFIRMATION.COMPLETED: {
      draft.askConfirmation = action.payload;
      break;
    }
    case LOGGED_OUT_ACTIONTYPE.SUCCESS:
    case RESET_APP_DATA_ACTIONTYPE.TRIGGER:
      return initialState;
  }
}, initialState);

export default entityDialogReducer;
